// extracted by mini-css-extract-plugin
export default {"introBarContainer":"BaseSingleViewHeader_introBarContainer__fuiYf"};